var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockOpened(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    width: 160,
    height: 160,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 5,
    d: "M80 157.5C37.14 157.5 2.5 122.86 2.5 80C2.5 37.14 37.14 2.5 80 2.5C122.86 2.5 157.5 37.14 157.5 80C157.5 122.86 122.86 157.5 80 157.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "none",
    d: "M115 74.25L115 126L46 126L46 74.25L97.75 74.25L97.75 57C97.75 54.54 97.32 52.27 96.45 50.17C95.58 48.08 94.37 46.26 92.81 44.74C91.25 43.21 89.42 42 87.33 41.1C85.23 40.2 82.96 39.75 80.5 39.75C78.04 39.75 75.77 40.18 73.67 41.05C71.58 41.92 69.76 43.13 68.24 44.69C66.71 46.25 65.5 48.08 64.6 50.17C63.7 52.27 63.25 54.54 63.25 57L57.5 57C57.5 53.74 58.08 50.71 59.25 47.93C60.42 45.14 62.04 42.7 64.1 40.6C66.17 38.51 68.6 36.89 71.38 35.75C74.17 34.61 77.21 34.03 80.5 34C83.76 34 86.79 34.58 89.57 35.75C92.36 36.92 94.8 38.54 96.9 40.6C98.99 42.67 100.61 45.1 101.75 47.88C102.89 50.67 103.47 53.71 103.5 57L103.5 74.25L115 74.25ZM109.25 80L51.75 80L51.75 120.25L109.25 120.25L109.25 80Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockOpened);
export default __webpack_public_path__ + "static/media/lock-opened.50a78754ecfb454556750a6d5c032697.svg";
export { ForwardRef as ReactComponent };